const levelPrices = [0.00015, 0.00035, 0.0012, 0.0035, 0.01, 0.03, 0.07, 0.17, 0.35];

// export const id1Wallets = [
//     "0x83f7716b547e1826fc61dd17713d5e65c2855986", 
//     "0xce377d55d9a3d47323dea0752629ae1bcc839045", 
//     "0xe951aaaf198a50797898d57456898331b743789a", 
//     "0x8838270f4b426b1cfcb9d6a87ce308f7f75b99b9", 
//     "0x0924B2DAe8b82182BAFd94Bf66ff122Bd9Ed3F7b"
// ]

export default levelPrices;